module.exports = __webpack_public_path__ + "static/teaser-2acf79288e566f4e4a70029ae4d21dcc.mp4";